import {
  buildInitialDesiredWeeklyScheduleParams,
  IDesiredWeeklyScheduleParams,
} from 'main/components/family/DesiredWeeklyScheduleFields'
import { IChild } from 'main/gql/child'
import * as React from 'react'
import { ITrackData, track } from '../track'
import { CreateTourRequest_submitTourRequest_availabilities as IAvailability } from './gql/__generated__/CreateTourRequest'

import Availability from './steps/Availability'
import Confirmation from './steps/Confirmation'
import Details from './steps/Details'

import { RequestTourModal, RequestTourModal_user } from './gql'

import { Step } from './types'

interface IProps {
  data: RequestTourModal
  step: Step
  onChangeStep: (step: Step) => void
  onRequestClose: () => void
  trackData: ITrackData
}

export interface IOpening {
  date: Date
  beginsAt: string
}

export default function Content(props: IProps) {
  const { data, step, onChangeStep, onRequestClose, trackData } = props
  const { school, desiredWeeklySchedule, user, tourRequests } = data

  const [proposedOpenings, setProposedOpenings] = React.useState<IOpening[]>([])

  const [selectedChildren, setSelectedChildren] = React.useState<IChild[]>(
    initialSelectedChildren(user),
  )

  const [availabilities, setAvailabilities] = React.useState<IAvailability[]>([])

  const [desiredWeeklyScheduleParams, setDesiredWeeklyScheduleParams] =
    React.useState<IDesiredWeeklyScheduleParams>(
      buildInitialDesiredWeeklyScheduleParams(desiredWeeklySchedule),
    )

  const alreadySavedAvailabilities =
    tourRequests && tourRequests.length > 0 && tourRequests[0].availabilities

  if (!school) throw new Error('No selected opening')

  switch (step.__stepname) {
    case 'provide_availability':
      return (
        <Availability
          school={school}
          proposedOpenings={proposedOpenings}
          setProposedOpenings={setProposedOpenings}
          onComplete={() => {
            track('completed_availability', trackData)
            onChangeStep({ __stepname: 'review' })
          }}
        />
      )

    case 'review':
      if (!proposedOpenings || proposedOpenings.length === 0) throw new Error('No selected opening')
      return (
        <Details
          desiredWeeklyScheduleParams={desiredWeeklyScheduleParams}
          onChangeDesiredWeeklyScheduleParams={setDesiredWeeklyScheduleParams}
          school={school}
          children={user?.family.children || []}
          initialSelectedChildren={selectedChildren}
          proposedOpenings={proposedOpenings}
          onRequestOpeningSelection={() => onChangeStep({ __stepname: 'provide_availability' })}
          onComplete={mutationResult => {
            track('completed_review', trackData)
            setSelectedChildren([mutationResult.child])
            setAvailabilities(mutationResult.availabilities || [])
            onChangeStep({ __stepname: 'confirmation' })
          }}
        />
      )
    case 'confirmation':
      return (
        <Confirmation
          school={school}
          availabilities={alreadySavedAvailabilities || availabilities}
          onComplete={() => {
            track('completed_confirmation', trackData)
            onRequestClose()
          }}
        />
      )
    default:
      throw new Error('Unreachable case')
  }
}

function initialSelectedChildren(user: RequestTourModal_user | null) {
  if (!user) return []
  const {
    family: { children },
  } = user
  return children.length === 1 ? children : []
}
